<template>
  <v-snackbar
    top
    right
    :color="color"
    :timeout="-1"
    v-model="visible"
  >
    <v-icon class="mr-2">mdi-alert-circle-outline</v-icon>
    {{this.$store.state.snackbar.msg}}

    <template v-slot:action="{ attrs }">
      <v-btn
        fab
        text
        small
        v-bind="attrs"
        @click="close"
      >
        <v-icon dark>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  computed: {
    visible() {
      return this.$store.state.snackbar.visible;
    },
    color() {
      return this.$store.state.snackbar.color;
    },
  },
  methods: {
    close() {
      this.$store.commit('snackbar/ClOSE_SNACKBAR');
    }
  }
};
</script>
